import axios from "axios"
import { API_URL } from "../consts"

export const messageWOG = async(payload) => {
  const result = await axios.post(`${API_URL}/world-of-grieflings/message`, payload)
  return result.data
}

export const getWOGContacts = async() => {
  const result = await axios.get(`${API_URL}/world-of-grieflings/contacts-list`)
  return result.data.contacts
}
